/* template */
<template><div class="refund-nav"><div v-if="(userGroup)"><div class="title" v-if="(title)">{{ title }}</div><div v-else>改签</div></div><template v-else><div :class="(process !== 0 ? 'refund-nav-not-now': '')">选车次</div><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/mdl6ftoC1AYy5JNVWNNrH.png" class="refund-nav-arrow"></mpx-image><div :class="(process !== 1 ? 'refund-nav-not-now': '')">选坐席</div><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/mdl6ftoC1AYy5JNVWNNrH.png" class="refund-nav-arrow"></mpx-image><div :class="(process !== 2 ? 'refund-nav-not-now': '')">选乘客</div></template></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m262f9081"}'>
  .refund-nav
    display flex
    flex-direction row
    align-items center
    justify-content center
    font-size 14px
    font-weight 400
    font-family PingFangSC-Medium
    color #000004
    &-arrow
      width 13px
      height 4px
      margin 0 4px
    &-not-now
      color rgba(0, 0, 4, 0.16)
  .title
    font-size 18px
    font-family PingFangSC-Medium
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m262f9081"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex262f9081%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex262f9081%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m262f9081"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index262f9081/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
